import { Card, CardCategories } from "@types"
import * as React from "react"
import { Dispatch, SetStateAction } from "react"

interface GrayPricingCardProps {
  cards: Card
  isSelectedCard?: boolean
  setSelectedCard?: Dispatch<SetStateAction<Card | undefined>>
  setShowQuote?: Dispatch<SetStateAction<boolean>>
}
export const GrayPricingCard = ({
  cards,
  setSelectedCard,
  isSelectedCard,
  setShowQuote,
}: GrayPricingCardProps) => {
  const [checkedItems, setCheckedItems] = React.useState(
    (cards.categories as CardCategories[]).map((category) =>
      (category?.list ?? []).map((item) => ({ ...item, isChecked: false }))
    )
  )

  const toggleCheckbox = (categoryIndex: number, listIndex: number) => {
    const updatedCheckedItems = [...checkedItems]
    updatedCheckedItems[categoryIndex][listIndex].isChecked =
      !updatedCheckedItems[categoryIndex][listIndex].isChecked
    setCheckedItems(updatedCheckedItems)
  }
  const toggleRadioOption = (categoryIndex: number, listIndex: number) => {
    const updatedCheckedItems = [...checkedItems]

    // Check if the clicked item is already checked
    const isCurrentlyChecked =
      updatedCheckedItems[categoryIndex][listIndex].isChecked

    // Uncheck all items in the category, or uncheck the current item if it is already checked
    updatedCheckedItems[categoryIndex] = updatedCheckedItems[categoryIndex].map(
      (item, i) => ({
        ...item,
        isChecked: i === listIndex ? !isCurrentlyChecked : false, // Toggle the current item
      })
    )

    setCheckedItems(updatedCheckedItems)
  }
  const getSelectedCard = () => {
    const selectedCard = {
      ...cards,
      categories:
        cards.categories &&
        cards.categories.map((category, categoryIndex) => ({
          ...category,
          list:
            category.list &&
            category.list.map((item, listIndex) => ({
              ...item,
              isChecked: checkedItems[categoryIndex][listIndex].isChecked,
            })),
        })),
    }
    if (setSelectedCard) setSelectedCard(selectedCard)
  }
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <>
      {/* small-business-with-gray */}
      <div
        className={`bg-gray-card bg-input py-4 shadow-lg rounded-lg col-span-6 ${theme == "glassy" ? "border border-white border-t-0" : theme === "light" ? "" : theme === "dark" ? "" : "border border-white border-t-0"}`}
      >
        <div className="flex rounded-2xl mx-auto bg-light-gray bg-btn px-4 bg-glass max-w-[60%] w-fit">
          <div className="text-center w-full rounded-lg">
            <p className="text-dark-gray text-center font-semibold text-nowrap text-sm py-2">
              {cards.cardTitle}
            </p>
          </div>
        </div>
        <div className="pt-8 px-10">
          <div className="px-2">
            <h3 className="text-6xl font-semibold text-[#ACCACF] text-center">
              {cards.cardPrice}
            </h3>
            <p className="text-black text-center pt-3">{cards.subtitle}</p>
            <p className="text-dark-gray font-semibold text-center pt-3">
              {cards.description}
            </p>
          </div>
          <div className="flex justify-center pt-4">
            <hr className="w-4/6 opacity-30" />
          </div>

          {cards?.categories &&
            cards?.categories.map((category: CardCategories, index) => (
              <>
                <div key={index} className="relative w-fit mx-auto">
                  <div className="h-2"></div>
                  <p className="text-black text-center text-nowrap text-lg font-semibold pt-3">
                    {category.title}{" "}
                    <span className="text-xs text-dark-gray">
                      {category.titleSubDescription}
                    </span>
                  </p>
                </div>
                {category.list &&
                  category.type === "tick" &&
                  category?.list.map((list) => (
                    <div className="text-black flex gap-2 items-center text-xs font-normal pt-2">
                      <div className="stroke">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="8"
                          viewBox="0 0 10 8"
                          fill="none"
                        >
                          <path
                            d="M1 4.2L3.66667 7L9 1"
                            stroke=""
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <p className="text-gray text-nowrap font-semibold">
                        {list.title}{" "}
                        <span className="text-[10px] text-dark-gray-secondary">
                          {list.titleSubDescription}
                        </span>
                      </p>
                    </div>
                  ))}
                {category.list && category.type === "radioOptions" && (
                  <div className="text-white grid-container pt-2 gap-2">
                    {category?.list.map((list, i) => (
                      <>
                        {isSelectedCard !== true ? (
                          <div
                            key={i}
                            className=" col-span-5 my-1 gap-2 flex items-center"
                          >
                            <div className="flex gap-2 items-center">
                              <div className="radio-border rounded-full flex items-center justify-center p-1 w-6 h-6">
                                <input
                                  className="input-radio !w-3 !h-3"
                                  type="radio"
                                  id={list.title}
                                  value={list.title}
                                  name="grayCard"
                                  checked={
                                    list.isChecked ||
                                    checkedItems[index][i].isChecked
                                  }
                                  onClick={() => toggleRadioOption(index, i)}
                                />
                              </div>
                              <label
                                className="text-black text-xs text-nowrap"
                                htmlFor={list.title}
                              >
                                {list.title}
                              </label>
                            </div>
                          </div>
                        ) : (
                          <>
                            {list.isChecked && (
                              <div
                                key={i}
                                className=" col-span-5 my-1 gap-2 flex items-center"
                              >
                                <div className="flex gap-2 items-center">
                                  <div className="border border-black rounded-full flex items-center justify-center p-1 w-6 h-6">
                                    <input
                                      className="input-radio !w-3 !h-3"
                                      type="radio"
                                      id={list.title}
                                      value={list.title}
                                      name="grayCard"
                                      checked={list.isChecked}
                                      onClick={() =>
                                        toggleRadioOption(index, i)
                                      }
                                    />
                                  </div>
                                  <label
                                    className="text-black text-xs"
                                    htmlFor={list.title}
                                  >
                                    {list.title}
                                  </label>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    ))}
                  </div>
                )}
                {category.list && category.type === "selectionOptions" && (
                  <div className="text-black grid-container justify-center flex px-16 pt-2 gap-2">
                    {category?.list.map((list, i) => (
                      <>
                        {isSelectedCard !== true ? (
                          <div
                            key={i}
                            className=" col-span-8 my-1 gap-2 flex items-center"
                          >
                            <div
                              onClick={() => toggleCheckbox(index, i)}
                              className="checkbox cursor-pointer border border-black w-6 h-6"
                            >
                              {(checkedItems[index][i].isChecked ||
                                list.isChecked) && (
                                <div className="checked bg-[#7B68EC] h-full w-full text-center text-white">
                                  ✓
                                </div>
                              )}
                            </div>
                            <p className="text-black text-xs">{list.title}</p>
                          </div>
                        ) : (
                          <>
                            {list.isChecked && (
                              <div
                                key={i}
                                className=" col-span-8 my-1 gap-2 flex items-center"
                              >
                                <div
                                  onClick={() => toggleCheckbox(index, i)}
                                  className="checkbox cursor-pointer border border-black w-6 h-6"
                                >
                                  {(checkedItems[index][i].isChecked ||
                                    list.isChecked) && (
                                    <div className="checked bg-[#7B68EC] h-full w-full text-center text-white">
                                      ✓
                                    </div>
                                  )}
                                </div>
                                <p className="text-black text-xs">
                                  {list.title}
                                </p>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    ))}
                  </div>
                )}
              </>
            ))}
          <div>
            <p className="text-black text-xs text-center pt-8">
              {cards.footerDescription}{" "}
              <span className="text-dark-gray">
                {cards.footerSubDescription}
              </span>
            </p>
          </div>
          <div className="pt-4">
            {isSelectedCard !== true && (
              <button
                onClick={() => {
                  getSelectedCard()
                  setShowQuote && setShowQuote(true)
                }}
                className="card-btn-border border-black bg-btn text-sm py-3 text-black w-full p-2 rounded-3xl"
              >
                Download Quote
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
